import axios from "axios";
import { API_CONFIG, joinApiUrl } from "../config/api.config";
import { clearTenantOwnerCache } from "./tenantOwnerService";

export const AUTH_TOKEN_KEY = "atht";
export const AUTH_USER_ID_KEY = "iduht";
export const AUTH_USER_NAME_KEY = "hname";
export const AUTH_ROLE_KEY = "role";
export const AUTH_ROLE_TYPE_KEY = "role-type";
export const AUTH_FRONTEND_USER_TYPE = "owner";
export const ALMACEN_USER = AUTH_FRONTEND_USER_TYPE;
export const AUTH_API_USER_TYPE = "owner";

const extractToken = (data) =>
  data?.token || data?.accessToken || data?.access_token || data?.data?.token || "";

const extractUser = (data) => data?.user || data?.data?.user || null;

export const normalizeFrontendUserType = (type) => {
  const normalizedType = String(type || "").toLowerCase();
  return normalizedType === "almacen" || !normalizedType
    ? AUTH_FRONTEND_USER_TYPE
    : normalizedType;
};

export const getStoredToken = () => localStorage.getItem(AUTH_TOKEN_KEY);

export const getStoredRole = () => normalizeFrontendUserType(localStorage.getItem(AUTH_ROLE_KEY));

export const getStoredRoleType = () =>
  normalizeFrontendUserType(localStorage.getItem(AUTH_ROLE_TYPE_KEY));

export const setStoredSession = ({ token, user } = {}) => {
  if (!token) return;

  // Limpiar cualquier dato de sesiones anteriores para evitar mezclar cuentas
  clearStoredSession();

  localStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(AUTH_ROLE_KEY, AUTH_FRONTEND_USER_TYPE);
  localStorage.setItem(AUTH_ROLE_TYPE_KEY, AUTH_FRONTEND_USER_TYPE);

  const userId = user?._id || user?.id || user?.userId;
  if (userId) localStorage.setItem(AUTH_USER_ID_KEY, userId);

  const userName = [user?.firstName || user?.name, user?.lastName].filter(Boolean).join(" ");
  if (userName) localStorage.setItem(AUTH_USER_NAME_KEY, userName);

  const tenantId = user?.tenantId || user?.tenant_id;
  if (tenantId) localStorage.setItem("tenantId", tenantId);
};

export const clearStoredSession = () => {
  [
    AUTH_TOKEN_KEY,
    "rtht",
    AUTH_USER_ID_KEY,
    AUTH_USER_NAME_KEY,
    AUTH_ROLE_KEY,
    AUTH_ROLE_TYPE_KEY,
    "tenantId",
    "tenant_id",
  ].forEach((key) => localStorage.removeItem(key));
  clearTenantOwnerCache();
};

export const login = async ({ email, password }) => {
  const response = await axios.post(joinApiUrl(API_CONFIG.BASE_URL, "/api/v2/auth/login"), {
    email,
    password,
    type: AUTH_API_USER_TYPE,
  });

  const token = extractToken(response.data);
  const user = extractUser(response.data);

  if (!token) {
    throw new Error("La API no devolvio token de autenticacion.");
  }

  setStoredSession({ token, user });
  return { token, user, raw: response.data };
};

export const logout = () => {
  clearStoredSession();
};

export const requestPasswordReset = async ({ email }) => {
  const response = await axios.post(joinApiUrl(API_CONFIG.BASE_URL, "/api/v2/auth/reset"), {
    email,
  });
  return response.data;
};
